/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import SzczegolyUrzedu from './SzczegolyUrzedu';
import Cmentarze from './Cmentarze';
import SzczegolyEuslugi from '../../euslugi/szczegolyEuslugi/SzczegolyEuslugi';
import ServicesLayout from '../../../components/ServicesLayout';
import DeklaracjaDostepnosci from '../../../components/DeklaracjaDostepnosci/DeklaracjaDostepnosci';
import AnkietaSatysfakcji from '../../../components/AnkietaSatysfakcji/AnkietaSatysfakcji';

import { addVisit, fetchArms } from '../../../lib/utils';
import NotFound from '../../notFound/NotFound';

const notFoundComponent = {
  title: 'Nie znaleziono zasobu',
  component: <ServicesLayout absoluteFooter><NotFound title={''} /></ServicesLayout>,
  status: 404,
}

/* eslint-disable global-require*/
export default {

  path: '/:prefix',
  children: [
    {
      path: '/',
      async action(ctx) {
        const { store } = ctx;
        const state = await store.getState();
        if (state.district.districts.hasOwnProperty(ctx.params.prefix)) {
          addVisit(ctx.params.prefix, '4');
          const districtName = state.district.districts[ctx.params.prefix].placeOfSettling;
          const districtEnabled = state.district.districts[ctx.params.prefix].showOnList;
          return districtEnabled ? {
            title: `${districtName} - e-spdp.pl`,
            component: <ServicesLayout active="district" prefix={ctx.params.prefix}><SzczegolyUrzedu user={state.user} prefix={ctx.params.prefix}/></ServicesLayout>,
            description: `${districtName} - e-spdp.pl`,
          } : 
          notFoundComponent;
        } else {
          return notFoundComponent;
        }

      },
    },
    {
      path: '/cmentarze',
      async action(ctx) {
        const { store } = ctx;
        const state = await store.getState();
        const districtName = state.district.districts[ctx.params.prefix].placeOfSettling;
        const districtEnabled = state.district.districts[ctx.params.prefix].showOnList;
        return districtEnabled ? {
          title: `Cmentarze - ${districtName} - e-spdp.pl`,
          component: <ServicesLayout active="district" prefix={ctx.params.prefix} ><Cmentarze user={state.user} prefix={ctx.params.prefix} /></ServicesLayout>,
          description: `Cmentarze - ${districtName} - e-spdp.pl`,
        } :
        notFoundComponent;
      },
    },
    {
      path: '/deklaracja-dostepnosci',
      async action(ctx) {
        const { store } = ctx;
        const state = await store.getState();
        const districtName = state.district.districts[ctx.params.prefix].placeOfSettling;
        const districtEnabled = state.district.districts[ctx.params.prefix].showOnList;
        return districtEnabled ? {
          title: `Deklaracja dostępności - ${districtName} - e-spdp.pl`,
          component: <ServicesLayout active="district" prefix={ctx.params.prefix}>
            <DeklaracjaDostepnosci prefix={ctx.params.prefix} />
          </ServicesLayout>,
          description: `Deklaracja dostępności - ${districtName} - e-spdp.pl`,
        } :
        notFoundComponent;
      },
    },
    {
      path: '/ankieta-satysfakcji',
      async action(ctx) {
        const { store } = ctx;
        const state = await store.getState();
        const districtName = state.district.districts[ctx.params.prefix].placeOfSettling;
        const districtEnabled = state.district.districts[ctx.params.prefix].showOnList;
        return districtEnabled && state.district.districts[ctx.params.prefix] && state.district.districts[ctx.params.prefix].questionnaireEnabled ? {
          title: `Badanie satysfakcji użytkowników - ${districtName} - e-spdp.pl`,
          component: <ServicesLayout active="district" prefix={ctx.params.prefix}>
            <AnkietaSatysfakcji prefix={ctx.params.prefix} />
          </ServicesLayout>,
          description: `Badanie satysfakcji użytkowników - ${districtName} - e-spdp.pl`,
        } :
        notFoundComponent;
      },
    },
    {
      path: '/:eusluga',
      async action(ctx) {
        return {
          title: "e-usługi - e-spdp.pl",
          component: <ServicesLayout active="district" prefix={ctx.params.prefix}><SzczegolyEuslugi prefix={ctx.params.eusluga} /></ServicesLayout>,
          description: "e-usługi - e-spdp.pl",
        };
      },
    },
  ],
};



// WEBPACK FOOTER //
// src/routes/urzad/szczegolyUrzedu/index.js